<div class="flex flex-col gap-1">
  <h4
    class="flex flex-row items-center gap-1"
    data-test-id="schedule-times-fields-time-title"
  >
    <span class="swatch available"></span>
    Available
  </h4>
  <div class="grid grid-cols-2 grid-rows-1 gap-2" [formGroup]="time">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <mat-label data-test-id="schedule-times-fields-time-start-label">
        Start
      </mat-label>
      <mat-select
        formControlName="start"
        data-test-id="schedule-times-fields-time-start"
        [errorStateMatcher]="rangeErrorStateMatcher"
      >
        @for (option of startTimeOptions; track option) {
          <mat-option
            data-test-id="schedule-times-fields-time-start-option"
            [value]="option"
          >
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <mat-label data-test-id="schedule-times-fields-time-end-label">
        End
      </mat-label>
      <mat-select
        formControlName="end"
        data-test-id="schedule-times-fields-time-end"
        [errorStateMatcher]="rangeErrorStateMatcher"
      >
        @for (option of endTimeOptions; track option) {
          <mat-option
            data-test-id="schedule-times-fields-time-end-option"
            [value]="option"
          >
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  @let timeRangeError = getTimeRangeError();
  @if (timeRangeError) {
    <mat-error
      class="form-error inset"
      data-test-id="schedule-times-fields-time-error"
    >
      {{ timeRangeError }}
    </mat-error>
  }
  <ng-content />
</div>
<div class="flex flex-col gap-1">
  <h4
    class="flex flex-row items-center gap-1"
    data-test-id="schedule-times-fields-preferred-times-title"
  >
    <span class="swatch preferred"></span>
    Preferred
  </h4>

  <div class="flex flex-col gap-2">
    <p class="hint" data-test-id="schedule-times-fields-preferred-times-hint">
      Optional. Mark part or all of the available times as preferred.
    </p>
    @let preferredTimesControls = isAllPreferred ? [] : preferredTimes.controls;

    @for (control of preferredTimesControls; track control) {
      <div
        class="flex flex-col gap-1"
        data-test-id="schedule-times-fields-preferred-times"
        [formGroup]="control"
      >
        <div class="preferred-range flex flex-row gap-2 items-center">
          <mat-form-field class="flex-1" subscriptSizing="dynamic">
            <mat-select
              formControlName="start"
              aria-label="Preferred start time"
              data-test-id="schedule-times-fields-preferred-times-start"
              [errorStateMatcher]="rangeErrorStateMatcher"
            >
              @for (option of preferredTimeOptions; track option) {
                <mat-option
                  data-test-id="schedule-times-fields-preferred-times-start-option"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="flex-1" subscriptSizing="dynamic">
            <mat-select
              formControlName="end"
              aria-label="Preferred end time"
              data-test-id="schedule-times-fields-preferred-times-end"
              [errorStateMatcher]="rangeErrorStateMatcher"
            >
              @for (option of preferredTimeOptions; track option) {
                <mat-option
                  data-test-id="schedule-times-fields-preferred-times-end-option"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button
            class="shrink-0"
            mat-icon-button
            type="button"
            title="Remove preferred range"
            data-test-id="schedule-times-fields-preferred-times-remove-button"
            (click)="removePreferredTimeRange($index)"
          >
            <mat-icon>remove_circle_outline</mat-icon>
          </button>
        </div>
        @let preferredTimeRangeError = getTimeRangeError(control);
        @if (preferredTimeRangeError) {
          <mat-error
            class="form-error preferred-range-error"
            data-test-id="schedule-times-fields-preferred-times-error"
          >
            {{ preferredTimeRangeError }}
          </mat-error>
        }
      </div>
    }
    <div class="flex flex-row flex-wrap gap-2">
      <button
        class="preferred-action"
        mat-stroked-button
        type="button"
        color="primary"
        data-test-id="schedule-times-fields-preferred-times-add-button"
        (click)="addPreferredTimeRange()"
      >
        <mat-icon>add</mat-icon>
        Add range
      </button>
      <button
        class="preferred-action"
        type="button"
        color="primary"
        data-test-id="schedule-times-fields-all-preferred-button"
        [matButton]="isAllPreferred ? 'filled' : 'outlined'"
        [attr.aria-pressed]="isAllPreferred"
        (click)="toggleAllPreferred()"
      >
        All preferred
      </button>
    </div>
  </div>
</div>
